export function mobileNav() {
    const body = $("body");
    const btnMenu = $(".btn-menu");
    const mainNav = $('.main-menu');
    const mainNavItems = mainNav.find('.menu-item-has-children');
    const arrowButton = `<button class="arrow-button">
                            <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 5.35199L11.8469 6.02798L8.37065 9.62659C7.88978 10.1245 7.11016 10.1245 6.62929 9.62659L3.15301 6.02798L2.5 5.35199L3.80601 4L4.45902 4.67599L7.49997 7.82399L10.541 4.67599L11.1939 4L12.5 5.35199Z" fill="white"/>
                            </svg>
                        </button>`;
    let activeMenuItem;

    //burger
    btnMenu.on("click", function (e) {
        let $this = $(this);
        $this.text() === 'Menu' ? $this.text('Close') : $this.text('Menu');
        if (!$this.hasClass("open")) {
            $this.addClass("open");
            body.addClass("menu-opened");
        } else {
            $this.removeClass("open");
            body.removeClass("menu-opened");
        }
        // mainNav.find('> li').removeClass('active').show();
        // mainNav.find('> .menu-item-has-children').removeClass('active');
        e.preventDefault();
    });

    //append arrow and back buttons
    mainNavItems.each((i, item) => {
        const menuList = $(item).find(' > .sub-menu');
        if (!$(item).find('.arrow').length) {
            $(arrowButton).insertBefore(menuList, null);
        }
    });


    function closeDropdown(e) {
        if (!$('.main-menu .menu-item-has-children').has(e.target).length > 0) {
            $('.main-menu .menu-item-has-children').removeClass('active').find(".sub-menu").slideUp();
            window.removeEventListener('click', closeDropdown);
        }
    }

    //show/hide menu
    $(document).on("click", ".main-menu .menu-item-has-children", function (e) {
        // const target = $(e.target);

        // if (target.closest('.arrow-button').length) {
        // activeMenuItem = target.closest('.arrow-button').parent();
        activeMenuItem = $(this);
        if (window.innerWidth < 1200) {
            if (!activeMenuItem.hasClass("active")) {
                activeMenuItem.siblings().removeClass('active').find(".sub-menu").slideUp();
                activeMenuItem.addClass("active").find(".sub-menu").slideDown();
            } else {
                activeMenuItem.removeClass("active").find(".sub-menu").slideUp();
            }
        }
        if (window.innerWidth > 1200 && body.hasClass('touch')) {
            if (!activeMenuItem.hasClass("active")) {
                activeMenuItem.siblings().removeClass('active').find(".sub-menu").fadeOut();
                activeMenuItem.addClass("active").find(".sub-menu").fadeIn();
            } else {
                activeMenuItem.removeClass("active").find(".sub-menu").fadeOut();
            }
            // window.addEventListener('click', closeDropdown);
        }
        // }
    });


    // //show/hide menu
    // $(document).on("click", ".main-menu .arrow-button", function () {
    //     let $this = $(this);
    //     let parent = $this.parent();
    //     if ($(window).width() < 1200) {
    //         if (!parent.hasClass("active")) {
    //             parent.addClass("active").find(".sub-menu").slideDown();
    //         } else {
    //             parent.removeClass("active").find(".sub-menu").slideUp();
    //         }
    //     } else {
    //         if (!parent.hasClass("active")) {
    //             parent.addClass("active").find(".sub-menu").fadeIn();
    //         } else {
    //             parent.removeClass("active").find(".sub-menu").fadeOut();
    //         }
    //     }
    // });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js